"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mask = exports.masker = exports.unMask = void 0;
var regexMap = {
    9: new RegExp(/[0-9]/),
    A: new RegExp(/[a-zA-Z]/),
    S: new RegExp(/[0-9a-zA-Z]/),
};
var unMask = function (value) { return value.replace(/\W/g, ''); };
exports.unMask = unMask;
var masker = function (value, pattern, options) {
    var patternCharList = pattern.split('');
    var unmaskedValue = (0, exports.unMask)(String(value));
    var output = [];
    var valueIndex = 0;
    for (var i = 0; i < patternCharList.length; i++) {
        var patternChar = pattern[i];
        var valueChar = unmaskedValue[valueIndex];
        var regex = regexMap[patternChar];
        if (valueChar === patternChar) {
            output[i] = valueChar;
            valueIndex++;
            continue;
        }
        if (!regex) {
            output[i] = patternChar;
            continue;
        }
        if (valueChar && regex.test(valueChar)) {
            output[i] = valueChar;
            valueIndex++;
            continue;
        }
        if (options === null || options === void 0 ? void 0 : options.placeholder) {
            output[i] = options.placeholder;
            continue;
        }
        if (output.length < patternCharList.length &&
            /\W/.test(output[output.length - 1])) {
            output.pop();
        }
        break;
    }
    return output.join('');
};
exports.masker = masker;
var multimasker = function (value, patterns, options) {
    return (0, exports.masker)(value, patterns.reduce(function (memo, pattern) { return (value.length <= (0, exports.unMask)(memo).length ? memo : pattern); }, patterns[0]), options);
};
var mask = function (value, pattern, options) {
    return typeof pattern === 'string'
        ? (0, exports.masker)(value, pattern || '', options)
        : multimasker(value, pattern, options);
};
exports.mask = mask;
